module.exports = __webpack_public_path__ + "static/media/cc_logo.36e92a2b.svg";